import { Button } from 'primereact/button';
import { useState } from 'react';
import { InputText } from 'primereact/inputtext';

type TypeInConfirmationFieldsProps = {
  onReject: () => void;
  onConfirm: () => void;
  label: string;
  word: string;
};

const TypeInConfirmationFields = ({
  onReject,
  onConfirm,
  label,
  word,
}: TypeInConfirmationFieldsProps) => {
  const [content, setContent] = useState('');

  return (
    <div>
      <div className="mb-1">{label}</div>
      <div>
        <label htmlFor="contractName" className="text-standard block mb-2">
          Please write <span className="errorText font-bold mr-1">{word}</span>
          below:
        </label>
        <InputText
          placeholder={word}
          className={`w-full blackText text-standard`}
          autoComplete="off"
          value={content}
          onChange={(e) => {
            setContent(e.target.value);
          }}
        />
      </div>
      <div className="flex justify-content-end gap-2 mt-5 pb-2">
        <Button
          onClick={onReject}
          className="blackText font-bold transparent border-none hover:bg-gray-200 active:bg-gray-200 active:text-black-alpha-90 hover:text-black-alpha-90"
        >
          No
        </Button>
        <Button
          className="bluwaiBlue font-bold border-none mr-2"
          onClick={() => {
            onConfirm();
          }}
          disabled={content !== word}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default TypeInConfirmationFields;
